import Cookie from '/app/utils/cookie';
import Pusher from 'pusher-js';
import { useComputedProperty } from '/app/utils/helpers';
import { defineAppPlugin } from '/app/utils/app';
import { config } from '/app/config';

export const pusher = new Pusher(
    config.pusher.appKey, {
    cluster: config.pusher.cluster,
    authEndpoint: config.pusher.authEndpoint,
    auth: {
        headers: useComputedProperty({
            'Authorization': () => `Bearer ${Cookie.get('notification_token')}`
        }),
    }
});

export default defineAppPlugin(() => {});
